import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import './fonts/Inter/Inter-VariableFont_slnt,wght.ttf';
import './fonts/Roboto/Roboto-Regular.ttf';
import './fonts/LuckiestGuy/LuckiestGuy-Regular.ttf';

ReactDOM.render(
    <App />,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
